import { render, staticRenderFns } from "./hs-file.vue?vue&type=template&id=06336843&scoped=true&"
import script from "./hs-file.vue?vue&type=script&lang=js&"
export * from "./hs-file.vue?vue&type=script&lang=js&"
import style0 from "./hs-file.vue?vue&type=style&index=0&id=06336843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06336843",
  null
  
)

export default component.exports